import PropTypes from "prop-types"
import React, { useState } from "react"
import { Container, Navbar, Nav, NavDropdown, Row, Col } from "react-bootstrap";

import vostronetLogo from "../images/vostronet-logo-mono.svg";

const Header = ({ title }) => {
  const [mobileMenuToggle, setMobileMenuToggle] = useState(false);
  const [internetMenuToggle] = useState(false);
  // const whiteThemePages = [
  //   "Student Accommodation",
  //   "Internet Environments",
  //   "Build-to-Rent",
  //   "Hotel",
  //   "Public Wi-Fi",
  //   "Co-working",
  //   "About Us",
  //   "Our Network",
  //   "Contact Us",
  //   "Residential Fibre Network",
  //   "Software Platform",
  //   "404",
  // ];

  // const whiteTheme = whiteThemePages.includes(title);
  const whiteTheme = true;

  return (
    <header className={`navigation ${whiteTheme ? "nav-white" : ""} ${mobileMenuToggle ? "mobile-menu-active" : ""}`}>
      <Container className="navigation-container no-gutters">
        <Navbar expand="xl" className="nav-desktop">
          <Navbar.Brand href="/">
            <img src={vostronetLogo} className="nav-logo" alt="vostronet_logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="mr-auto basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav>
              <div className="dropdown nav-item">
                <a
                  href="https://vost.ro/lpfttpie"
                  aria-haspopup="true"
                  aria-expanded="false"
                  id="basic-nav-dropdown"
                  className={`dropdown-toggle nav-link ${title === "Internet Environments" ? "font-darkblue5" : "font-black"}`}
                  role="button">
                  Internet Environments
                </a>
              </div>

              <Nav.Link
                href="https://vost.ro/lpfttpcs"
                className={`mx-2 ${title === "Data Network and Enterprise" ? "font-darkblue5" : "font-black"}`}
              >
                Connectivity Solutions
              </Nav.Link>
              <Nav.Link href="https://vost.ro/lpfttpsp" className={`${title === "Software Platform" ? "font-darkblue5" : "font-black"}`}>Software Platform</Nav.Link>
              <Nav.Link
                href="https://vost.ro/lpfttpav"
                className={`mx-2 ${title === "About Us" ? "font-darkblue5" : "font-black"}`}
              >
                Why VostroNet
              </Nav.Link>
              <Nav.Link href="https://vost.ro/lpfttphc" className="mx-2 font-black" rel="noopener" target="_blank">{"Support"}</Nav.Link>
            </Nav>
            <Nav className="ml-auto">
              <Nav.Link className="link-contact btn btn-long mx-2 align-items-center" href="https://vost.ro/lpfttpcv">{"Contact Us"}</Nav.Link>
              <Nav.Link href="https://vost.ro/lpfttppv" className="btn-login btn mx-2 align-items-center" rel="noopener" target="_blank">
                <i className="fas fa-user mr-2" />{"Login"}
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Navbar expand="xl" className={`nav-mobile ${mobileMenuToggle ? "active" : ""}`}>
          <Navbar.Brand href="/">
            <img src={vostronetLogo} className="nav-logo" alt="vostronet_logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setMobileMenuToggle(!mobileMenuToggle)}>
            <div className="burger-group">
              <span className="burger-line line-1" />
              <span className="burger-line line-2" />
              <span className="burger-line line-3" />
            </div>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav justify className={` ${!internetMenuToggle ? "menushow-left" : "menuhide-right"} width-100`}>
              <NavDropdown.Divider />
              <Nav.Link href="https://vost.ro/lpfttpie">Internet Environments</Nav.Link>
              <NavDropdown.Divider />
              <Nav.Link href="https://vost.ro/lpfttpcs">Connectivity Solutions</Nav.Link>
              <NavDropdown.Divider />
              <Nav.Link href="https://vost.ro/lpfttpsp">Software Platform</Nav.Link>
              <NavDropdown.Divider />
              <Nav.Link href="https://vost.ro/lpfttpav">Why VostroNet</Nav.Link>
              <NavDropdown.Divider />
              <Nav.Link href="https://vost.ro/lpfttphc" target="_blank">{"Support"}</Nav.Link>
              <Row>
                <Col>
                  <a className="link-contact btn my-3 mx-auto" href="https://vost.ro/lpfttpcv">
                    <div className="mx-auto">
                      {"Contact Us"}
                    </div>
                  </a>
                </Col>
                <Col>
                  <a href="https://vost.ro/lpfttppv" className="btn-login btn mx-auto my-3" rel="noopener" target="_blank">
                    <div className="block-center">
                      <i className="fas fa-user mr-2" />{"Login"}
                    </div>
                  </a>
                </Col>
              </Row>
            </Nav>

            <Nav className={`internet-mobile-menu ${internetMenuToggle ? "menushow-right" : "menuhide-left"}`}>
              <NavDropdown.Divider />
              <Nav.Link className="mobile-internet-menu" href="https://vost.ro/lpfttpie">
                <i className="mr-3 fas fa-angle-left font-darkblue" />
                <div className="d-inline-block font-black mobile-internet-menu">
                  Internet Environments
                </div>
              </Nav.Link>
              <NavDropdown.Divider />
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </header>
  );
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
